/* The scholarships the landing page talks about, from the planner's research (apps/planner/prototype/v9/sch41.js),
   written by apps/planner/prototype/scripts/gen_v41.py; test/unit/landing.test.ts checks them against the research.
   SCHOLARSHIPS: the programs open now with a value (not paused, not loans, short exchanges or only for officials);
   SCH_BIGGEST: the most one of them is worth a year, in US dollars; EXAMPLE: what the page's example student (Amina,
   from Jordan, a master's in Canada, the UK or Germany) can apply for: how many, the most one is worth, the top five. */
export const SCHOLARSHIPS = 93;
export const SCH_BIGGEST = 73853;
export const EXAMPLE: { n: number; max: number; top: Array<{ id: string; en: string; ar: string; usd: number; dest: string; uni?: { en: string; ar: string } }> } = {
  "n": 24,
  "max": 73853,
  "top": [
    {
      "id": "gb-gates-cambridge",
      "en": "Gates Cambridge Scholarship",
      "ar": "منحة غيتس كامبريدج",
      "usd": 73853,
      "dest": "GB",
      "uni": {
        "en": "University of Cambridge",
        "ar": "جامعة كامبريدج"
      }
    },
    {
      "id": "gb-rhodes",
      "en": "Rhodes Scholarship",
      "ar": "منحة رودس",
      "usd": 71196,
      "dest": "GB",
      "uni": {
        "en": "University of Oxford",
        "ar": "جامعة أكسفورد"
      }
    },
    {
      "id": "jj-wbgsp",
      "en": "Joint Japan/World Bank Graduate Scholarship Program (JJ/WBGSP)",
      "ar": "برنامج المنح المشترك بين اليابان والبنك الدولي للدراسات العليا (JJ/WBGSP)",
      "usd": 65000,
      "dest": "MULTI"
    },
    {
      "id": "chevening",
      "en": "Chevening Scholarships",
      "ar": "منح تشيفنينغ",
      "usd": 53848,
      "dest": "GB"
    },
    {
      "id": "rotary-peace-fellowship",
      "en": "Rotary Peace Fellowships (master's degree)",
      "ar": "زمالات روتاري للسلام (ماجستير)",
      "usd": 50084,
      "dest": "MULTI"
    }
  ]
};
